export const EMOCIONES = [
  { key: "feliz", label: "Feliz", emoji: "😊" },
  { key: "entusiasmado", label: "Entusiasmado", emoji: "🤩" },
  { key: "tranquilo", label: "Tranquilo", emoji: "🙂" },
  { key: "cansado", label: "Cansado", emoji: "😴" },
  { key: "triste", label: "Triste", emoji: "😢" },
  { key: "enfadado", label: "Enfadado", emoji: "😠" },
  { key: "nervioso", label: "Nervioso", emoji: "😬" },
];

export const emocionInfo = (key) =>
  EMOCIONES.find((e) => e.key === key) || { key: "", label: "", emoji: "" };
